<template>
  <div class="timer-display" :style="{ fontFamily: selectedFont }">
    <h1>{{ formattedTime }}</h1>
  </div>
</template>

<script>
export default {
  props: {
    font: {
      type: String,
      default: 'Open Sans'
    }
  },
  data() {
    return {
      seconds: 0,
      selectedFont: this.font
    }
  },
  computed: {
    formattedTime() {
      const absSeconds = Math.abs(this.seconds);
      const hours = Math.floor(absSeconds / 3600);
      const minutes = Math.floor((absSeconds % 3600) / 60);
      const remainingSeconds = absSeconds % 60;
      const sign = this.seconds < 0 ? '-' : '';
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${sign}${remainingSeconds.toString().padStart(2, '0')}`;
    }
  },
  methods: {
    handleStorageChange(event) {
      if (event.key === 'timerSeconds') {
        this.seconds = parseInt(event.newValue || '0');
      }
    }
  },
  mounted() {
    window.addEventListener('storage', this.handleStorageChange);
    this.seconds = parseInt(localStorage.getItem('timerSeconds') || '0');
    if (localStorage.getItem('timerRunning') === 'true') {
      this.startTimer();
    }
  },
  beforeUnmount() {
    window.removeEventListener('storage', this.handleStorageChange);
  }
}
</script>

<style scoped>
.timer-display {
  font-size: 5rem;
  text-align: center;
}
</style>